import ITag from 'shared/model/ITags';

export type TagsSortMode = 'label' | 'new';

export const TAGS_SORT_STORAGE_KEY = 'tagsSortMode';

export const DEFAULT_TAGS_SORT_MODE: TagsSortMode = 'label';

export const readTagsSortMode = (): TagsSortMode =>
    localStorage.getItem(TAGS_SORT_STORAGE_KEY) === 'new' ? 'new' : DEFAULT_TAGS_SORT_MODE;

export const writeTagsSortMode = (mode: TagsSortMode): void => {
    localStorage.setItem(TAGS_SORT_STORAGE_KEY, mode);
};

export const sortTags = (tags: ITag[], mode: TagsSortMode): ITag[] => [...tags].sort((a, b) => (
    mode === 'label'
        ? a.label.localeCompare(b.label)
        : (Number(b.id) - Number(a.id)) || 0
));
